<!-- @format -->
<template>
    <div class="social-media-manage-widget">
        <loading-card :is-loading="isLoading" />
        <div class="widget-header">
            <h3>Manage Social Networks</h3>
            <div class="svg-container widget-close-button" @click="closeWidget()">
                <widget-close-svg />
            </div>
        </div>
        <div class="content-wrapper">
            <div v-if="currentContent === 'connectSocialMedia'">
                <social-media-manage-connection :social-type="widget.accountType" :error="error" />
            </div>
            <div v-else-if="currentContent === 'socialManage'">
                <social-media-manage-account :widget="widget" :item="item" />
            </div>
        </div>
        <div class="widget-footer">
            <div class="actions-container">
                <app-button class="transparent-btn" @click="closeWidget">Cancel</app-button>
            </div>
            <div v-if="!error" class="actions-container">
                <app-button v-if="hasBackAction" class="secondary-btn" @click="goBack">
                    <span class="fa fa-arrow-left"></span>
                    {{ backLabel }}
                </app-button>
                <app-button
                    v-if="social === 'facebook' || social === 'instagram'"
                    class="facebook-btn"
                    @click="goNext"
                >
                    <p23-facebook-svg />
                    Continue with Facebook
                </app-button>
                <app-button v-else @click="goNext">
                    {{ nextLabel }}
                    <span class="fa fa-arrow-right"></span>
                </app-button>
            </div>
        </div>
    </div>
</template>

<script>
import EventBus from '@/scripts/event-bus.js';

import { SocialMediaBoardServiceMixin } from '@/mixins/board/social-media-board-service-mixin';
const WidgetCloseSvg = () => import('@/components/svg/quick-add/widget-close-svg');
const AppButton = () => import('@/components/common/app-button');
const LoadingCard = () => import('@/components/common/loading-card');
const SocialMediaManageConnection = () =>
    import('@/components/sliding-widgets/social-media/social-media-manage-connection');
const SocialMediaManageAccount = () =>
    import('@/components/sliding-widgets/social-media/social-media-manage-account');
const P23FacebookSvg = () => import('@/components/svg/grid/p23-facebook-svg');

export default {
    name: 'social-media-manage-widget',

    components: {
        'app-button': AppButton,
        'loading-card': LoadingCard,
        'widget-close-svg': WidgetCloseSvg,
        'social-media-manage-connection': SocialMediaManageConnection,
        'social-media-manage-account': SocialMediaManageAccount,
        'p23-facebook-svg': P23FacebookSvg,
    },

    mixins: [SocialMediaBoardServiceMixin],

    props: {
        widget: {
            type: Object,
            required: true,
        },
    },

    data() {
        return {
            isLoading: false,
            social: 'LinkedIn',
            currentContent: 'connectSocialMedia',

            content: {
                connectSocialMedia: {
                    actions: {
                        nextAction: {
                            label: 'Next',
                            callback: () => {
                                this.connectSocialAccount();
                            },
                        },
                    },
                },

                socialManage: {
                    actions: {
                        nextAction: {
                            label: 'Finish',
                            callback: () => {
                                this.closeWidget();
                            },
                        },
                    },
                },
            },
        };
    },

    computed: {
        hasBackAction() {
            return this.content[this.currentContent].actions.backAction !== undefined;
        },

        nextLabel() {
            return this.content[this.currentContent].actions.nextAction.label;
        },

        goNext() {
            return this.content[this.currentContent].actions.nextAction.callback;
        },

        item() {
            return this.widget['item'];
        },

        error() {
            return this.widget.error ? true : false;
        },
    },

    mounted() {
        this.initialContent();
        this.social = this.widget.accountType;
    },

    methods: {
        closeWidget() {
            EventBus.$emit('close-widget', this.widget);
        },

        initialContent() {
            this.currentContent = this.widget.currentContent;
        },

        connectSocialAccount() {
            this.getRedirectToSocialMediaConnection(this.widget.accountType, this.widget.clientId);
            this.refreshEvent();
        },
    },
};
</script>

<style>
.social-media-manage-widget .widget-footer .actions-container {
    display: flex;
}

.social-media-manage-widget .widget-footer .transparent-btn {
    background: transparent;
    color: #877d88;
}

.social-media-manage-widget .widget-footer .transparent-btn:hover {
    background: #e1e0e5;
}

.social-media-manage-widget .widget-footer .secondary-btn {
    background: transparent;
    color: #18aeff;
    margin-right: 30px;
}

.social-media-manage-widget .widget-footer .secondary-btn:hover {
    background: #dbedfa;
}

.social-media-manage-widget .widget-footer .secondary-btn span.fa {
    margin-right: 10px;
}

.social-media-manage-widget .widget-footer .app-button:not(.secondary-btn) span.fa {
    margin-left: 10px;
}

.social-media-manage-widget .widget-footer .facebook-btn {
    background-color: #1877f2;
}

.social-media-manage-widget .widget-footer .p23-facebook-svg {
    margin-right: 10px;
}

.social-media-manage-widget .widget-footer .p23-facebook-svg .a {
    fill: #ffffff;
}

.social-media-manage-widget .widget-footer .p23-facebook-svg .b {
    fill: #1877f2;
}
</style>
